import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { api } from "@/lib/api";

export const RoomPhoto = ({ room, className = "h-40 w-full" }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!room?.has_photo) { setUrl(null); return undefined; }
    let u;
    api.get(`/rooms/${room.id}/photo`, { responseType: "blob", params: { v: room.photo_version } }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => setUrl(null));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [room?.id, room?.has_photo, room?.photo_version]);
  if (!url) return <div className={`${className} rounded-lg bg-slate-100 flex items-center justify-center text-slate-400`}><ImageOff className="h-6 w-6" /></div>;
  return <img data-testid={`room-photo-${room.id}`} src={url} alt={`Foto ${room.name}`} className={`${className} rounded-lg object-cover`} />;
};
